export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConsortiumPanel.vue?vue&type=template&id=16816906&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/party/ConsortiumPanel.vue?vue&type=template&id=16816906&scoped=true&
// module id = 1483
// module chunks = 0